/* vp-debrand.js -- strips the legacy "BEAM" brand name from the PDP copy.

   Loaded by the claude-4 and claude-5 Vegan Protein builder templates.

   There is exactly one occurrence in the arm's copy (audited across the whole
   rendered page, hidden and lazy content included):

     "...place our entire company's reputation behind our flavoring.
      at BEAM Be Amazing, we use two patented ingredients..."

   It reads "BEAM Be Amazing", so removing the word alone leaves the sentence
   correct -- "at Be Amazing, we use..." -- with no rewrite needed.

   ---- WHY THIS IS JS AND NOT A FIX IN THE SECTION ------------------------
   The string is hardcoded in sections/vp-pdp-2.liquid, which is 29,816 bytes
   and is SHARED with the vegan-protein-pdp-russ-claude-2 arm. Two problems with
   editing it there:
     1. themeFilesUpsert replaces a whole file -- there is no partial edit -- so
        a one-word change means re-emitting all 30KB of a section that every
        vegan arm depends on. That is a poor risk trade for one word.
     2. It would also change claude-2's copy, and claude-2 is a separate test
        arm we were not asked to touch.
   The cost of doing it here instead is that the word is present in the served
   HTML until this file runs. The paragraph sits far below the fold, so a
   visible flash is unlikely, but crawlers will still see it in source. If the
   word needs to be gone from the SOURCE too, the section is the place and all
   three arms should be done together.

   ---- SCOPE ----
   Confined to .vp-wrap, deliberately:
     - the product URL contains "beam"
       (/products/beam-be-amazing-vegan-plant-based-protein-powder-supplement)
       so links and form values must not be rewritten -- only text nodes are
       touched, never attributes or hrefs.
     - Yotpo review bodies are customer words. None currently contain "BEAM",
       but rewriting a customer's review would be misrepresenting them, so the
       reviews region is out of scope by construction.
     - the global header, footer and announcement bars are shared by every page
       on the store; editing them from a PDP arm would be a site-wide change.

   ---- BUG THAT COST A DEPLOY --------------------------------------------
   The first version prefiltered candidate nodes with
       if (v.indexOf("eam") === -1) continue;
   as a cheap way to skip most text before running the regex. indexOf is CASE
   SENSITIVE, and the one string on the page is uppercase "BEAM" -- which
   contains "EAM", not "eam". So the only node that needed fixing was the only
   node guaranteed to be skipped, the script reported no errors, and the word
   stayed on the page. There is no prefilter now: the regex is the single
   decision, so its case-insensitivity cannot be undone by a faster check
   sitting in front of it. */
(function(){
  "use strict";

  /* Whole word only, so "beams" or a hyphenated compound is left alone, and an
     optional possessive is absorbed so "BEAM's" would not leave a stray "'s".
     The trailing \s* collapses the gap the removed word leaves behind. */
  var WORD = /\bbeam(?:'s|’s)?\s*/gi;
  var HAS = /\bbeam\b/i;

  function clean(s){
    return s.replace(WORD, "")
            .replace(/[ \t]{2,}/g, " ")        /* no double space where it was */
            .replace(/\s+([,.;:!?])/g, "$1");  /* no space before punctuation */
  }

  function debrand(){
    var root = document.querySelector(".vp-wrap");
    if(!root) return 0;
    var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, hits = 0;
    while((n = walk.nextNode())){
      var v = n.nodeValue;
      if(!v || !HAS.test(v)) continue;
      var p = n.parentElement;
      if(!p) continue;
      /* never rewrite script/style payloads, and leave customer reviews alone */
      if(p.closest("script, style, noscript, [class*='yotpo']")) continue;
      var out = clean(v);
      if(out !== v){ n.nodeValue = out; hits++; }
    }
    return hits;
  }

  function run(){ try { debrand(); } catch(e){ /* copy fix must never throw */ } }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  /* Once more after load in case a section below the fold rendered late. */
  window.addEventListener("load", run);
})();